import { useSelector } from "react-redux";
import { Button } from "src/components";
import { RootState } from "src/context/store";

const UinOrderDetailsPopup = ({
  onConfirm,
  onBack,
  uinData,
  onConfirmLoading = false,
  divisionData = {},
  associatedCounterName,
  isApproval
}: {
  onBack?: () => void;
  onConfirm: () => void;
  uinData: any;
  onConfirmLoading?: boolean;
  divisionData?: any;
  associatedCounterName?: string;
  isApproval: boolean;
}) => {
  const { selectedCounterData, selectedCounterDataForUin } = useSelector((state: RootState) => state.ord);

  const selectedCounterDataForOrder = isApproval === true ? selectedCounterDataForUin?.[0] : selectedCounterData;

  // assc_counterhdr_id

  const arrayOfLinkTypesForAssociatedCounter = ["INDPH-HS", "INDPH", "INDPH-PH"];

  const isAssociatedCounter = arrayOfLinkTypesForAssociatedCounter.includes(selectedCounterDataForOrder?.drph_lnk_type?.dr_ph_lnk_code);
  return (
    <section className="px-5 py-3">
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-[#f8f8f8] text-[#49484C]">
            <th className="p-4" />
            <th className="p-4">As per Medvol</th>
            <th className="p-4">As per Company</th>
          </tr>
        </thead>
        <tbody>
          <tr className="bg-white text-[#49484C]">
            <td className="p-4 bg-[#f8f8f8]">Name</td>
            <td className="p-4 font-semibold">
              {isAssociatedCounter
                ? // ? divisionData?.assc_counterhdr_id?.counter_name
                  associatedCounterName
                : selectedCounterDataForOrder?.counter_location?.counter_hdr_id?.counter_name ?? "-"}
            </td>
            <td className="p-4 font-semibold">{uinData?.CompanyUINDetails?.Counter_Name ?? "-"}</td>
          </tr>
          <tr className="bg-white text-[#49484C]">
            <td className="p-4 bg-[#f8f8f8]">City</td>
            <td className="p-4 font-semibold">
              {isAssociatedCounter
                ? divisionData?.assc_counterhdr_id?.counter_location?.[0]?.address
                : selectedCounterDataForOrder?.counter_location?.city_code?.city_name ?? "-"}
            </td>
            <td className="p-4 font-semibold">{uinData?.CompanyUINDetails?.City ?? "-"}</td>
          </tr>
          <tr className="bg-white text-[#49484C]">
            <td className="p-4 bg-[#f8f8f8]">State</td>
            <td className="p-4 font-semibold">
              {isAssociatedCounter
                ? divisionData?.assc_counterhdr_id?.counter_location?.[0]?.city_code?.district_code?.state_code?.state_name
                : selectedCounterDataForOrder?.counter_location?.city_code?.district_code?.state_code?.state_name ?? "-"}
            </td>
            <td className="p-4 font-semibold">{uinData?.CompanyUINDetails?.State_Name ?? "-"}</td>
          </tr>
          <tr className="bg-white text-[#49484C]">
            <td className="p-4 bg-[#f8f8f8]">UIN Speciality</td>
            <td className="p-4 font-semibold">
              {isAssociatedCounter
                ? divisionData?.assc_counterhdr_id?.speciality_id?.speciality_desc
                : selectedCounterDataForOrder?.counter_location?.counter_hdr_id?.speciality_id?.speciality_desc}
            </td>
            <td className="p-4 font-semibold">{uinData?.CompanyUINDetails?.UIN_Speciality}</td>
          </tr>
          <tr className="bg-white text-[#49484C]">
            <td className="p-4 bg-[#f8f8f8]">Division Speciality</td>
            <td className="p-4 font-semibold">
              {isAssociatedCounter
                ? divisionData?.assc_counterhdr_id?.speciality_id?.speciality_desc
                : selectedCounterDataForOrder?.counter_location?.counter_hdr_id?.speciality_id?.speciality_desc}
            </td>{" "}
            <td className="p-4 font-semibold">{uinData?.CompanyUINDetails?.Division_Speciality}</td>
          </tr>
        </tbody>
      </table>
      <footer className="flex justify-end gap-3 items-center ">
        {onBack && (
          <Button onClick={onBack} className="border">
            Back
          </Button>
        )}
        <Button onClick={onConfirm} className="text-white bg-[#7F56D9]" loaderSize="small" isLoading={onConfirmLoading}>
          Confirm
        </Button>
      </footer>
    </section>
  );
};

export default UinOrderDetailsPopup;
